/**
 * In-memory access-token holder.
 *
 * SECURITY (#1, security audit 2026-06-12): access-токен больше НЕ хранится в
 * localStorage — любой XSS/сторонний скрипт на origin мог его прочитать. Теперь
 * токен живёт только в памяти вкладки. Персистентность между перезагрузками
 * обеспечивает httpOnly refresh-cookie (`initialize()` → `/api/auth/refresh`) и,
 * как fallback, device-credential. Перезагрузка страницы → токен ре-минтится из
 * cookie, разлогина нет.
 *
 * Модуль НИЧЕГО не импортирует → его могут использовать и `client.ts` (request
 * interceptor), и `authStore` без циклической зависимости (раньше эту роль
 * играл localStorage как общий канал).
 *
 * Multi-tab: каждая вкладка держит свой `memToken`; синхронизацию даёт
 * BroadcastChannel в client.ts (broadcastRefreshSuccess → setAccessTokenMem).
 */
let memToken: string | null = null;

export function getAccessToken(): string | null {
  return memToken;
}

export function setAccessTokenMem(token: string): void {
  memToken = token;
}

export function clearAccessTokenMem(): void {
  memToken = null;
}
